import React from 'react'
import styled from 'styled-components'

const SSPan = styled.span`
    display: flex;
    align-items: center;
`

interface ICalendarIconProps {
    className?: string
    fill?: string
    dataTestid?: string
    size?: number
    title?: string
    id?: string
    onMouseEnter?: () => void
    onMouseLeave?: () => void
}

export function CalendarIcon({
    fill,
    size = 14,
    title,
    dataTestid,
    id = 'calendar-icon',
}: ICalendarIconProps): React.ReactElement {
    return (
        <SSPan title={title} id={id} data-testid={dataTestid}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={fill ?? 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-calendar"
            >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
        </SSPan>
    )
}
